export enum FundRaiserCategory {
  AGRI = 0,
  POL = 1,
  PLANT = 2,
  COMMUNITY = 3,
  ANIMALS = 4,
  ENV = 5,
}